const updateURLParameters = (key: string, value: boolean) => {
  const searchParams = new URLSearchParams(window.location.search);

  // set parameter in URL
  searchParams.set(key, value.toString());

  // remove parameter if its value is false
  if (value === false) {
    searchParams.delete(key);
  }

  // create URL with new parameter
  const pathnameWithParameters = `${window.location.pathname}?${searchParams.toString()}`;
  window.history.replaceState(null, "", pathnameWithParameters);
};

export default updateURLParameters;
